const isType = (type) => (obj) => (Object.prototype.toString.call(obj) === `[object ${type}]`)

const isDate = isType('Date')

const isObject = isType('Object')

const isString = isType('String')

// const isDate = (date) => {
//   return isNaN(data) && !isNaN(Date.parse(data))
// }

const zeroize = (v) => {
  v = parseInt(v)
  return v < 10 ? "0" + v : v;
}


const parseDate = (date) => {
  const parsed = Date.parse(date);
  if (!isNaN(parsed)) {
    return new Date(parsed);
  }
  return new Date(date.replace(/-/g, '/').replace(/[a-z]+/ig, ' '));
}

const parseExprDate = (date) => {
  let a = new Date()
  date = date.replace(/(^\s*|\s*$)/g,'')
  if(isNaN(date) && !isNaN(Date.parse(date))){
    return new Date(Date.parse(date))
  }

  const units = date.replace(/\s*/g,'').match(/[+-]?\d*(s|m|h|d|w|M|\$h|\$d|\$w|\$M)/g) || []
  if( date.startsWith('(') ){
    let cur = (date.match(/^\(([^\)]+?)\)/) || ['',''])[1]
    if(cur){
      try{
        a = new Date(cur)
      }catch(e){}
    }
  }

  for(let expr of units){
    let hit = expr.match(/^([+-]?\d*)(s|m|h|d|w|M|\$h|\$d|\$w|\$M)$/)
    let v = hit[1] ? parseInt(hit[1]) : 0
    let t = hit[2]
    if( t == 's' ){
      a.setSeconds(a.getSeconds() + v)
    } else if( t == 'm' ){
      a.setMinutes(a.getMinutes() + v)
    } else if (t == 'h') {
      a.setHours(a.getHours() + v)
    } else if (t == 'd') {
      a.setDate(a.getDate() + v)
    } else if (t == 'w') {
      a.setDate(a.getDate() + v * 7)
    } else if (t == 'M') {
      a.setMonth(a.getMonth() + v)
    } else if (t == '$d') {
      a.setDate(a.getDate() + v)
      a.setHours(0)
      a.setSeconds(0)
      a.setMinutes(0)
      a.setMilliseconds(0)
    } else if (t == '$w') {
      a.setDate(a.getDate() - a.getDay() + 1 + v * 7)
      a.setHours(0)
      a.setSeconds(0)
      a.setMinutes(0)
      a.setMilliseconds(0)
    } else if (t == '$M') {
      a.setMonth(a.getMonth() + v)
      a.setDate(1)
      a.setHours(0)
      a.setSeconds(0)
      a.setMinutes(0)
      a.setMilliseconds(0)
    }
  }
  
  return a
}

const formatDate = (a , expr) => {
  if (expr == 'timestamp' || expr == 'ms') {
    return a.getTime()
  }
  else if( expr == 'iso' || expr == 'ISO' ){
    return a.toISOString()
  }
  else if(expr == 'date'){
    return a
  }

  let y = a.getFullYear(),
    M = a.getMonth() + 1,
    d = a.getDate(),
    D = a.getDay(),
    h = a.getHours(),
    m = a.getMinutes(),
    s = a.getSeconds(),
    w = a.getDay();

  //操作
  /*
  if(/(\>|\<|\=)+/.test(expr)){
    let m = expr.match(/(\>|\<|\=|\>\=|\<\=)(.*)/)
    if(m){
      let [,sym , val] = m
      let date
      try{

        val = new Date(val)
      }catch(e){
        return false
      }

      if(sym == '<'){
        return a.getTime() < val.getTime()
      }else if(sym == '>'){
        return a.getTime() > val.getTime()
      }else if(sym == '='){
        return a.getTime() == val.getTime()
      }
    }
  }
  */

  return expr.replace(/(?:s{1,2}|w{1,2}|m{1,2}|h{1,2}|d{1,2}|M{1,4}|y{1,4})/g, function(str) {

    switch (str) {
      case 's':
        return s;
      case 'ss':
        return zeroize(s);
      case 'm':
        return m;
      case 'mm':
        return zeroize(m);
      case 'h':
        return h;
      case 'hh':
        return zeroize(h);
      case 'd':
        return d;
      case 'w':
        return w;
      case 'ww':
        return w == 0 ? 7 : w;
      case 'dd':
        return zeroize(d);
      case 'M':
        return M;
      case 'MM':
        return zeroize(M);
      case 'MMMM':
        return ['十二', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一'][m] + '月';
      case 'yy':
        return String(y).substr(2);
      case 'yyyy':
        return y;
      default:
        return str.substr(1, str.length - 2);
    }
  })
}

const execOperate = (a,b,o) => {
  if(o == 'print' || o == '=>'){
    return formatDate(a , b)
  }
  else if( o == '>'){
    return a.getTime() > b.getTime()
  }
  else if( o == '<'){
    return a.getTime() < b.getTime()
  }
  else if( o == '==' || o == '='){
    return a.getTime() == b.getTime()
  }
  else if( o == '>=' ){
    return a.getTime() >= b.getTime()
  }
  else if( o == '<=' ){
    return a.getTime() <= b.getTime()
  }
}

export const moment = (date, expr = 'yyyy-MM-dd') => {
  if (!date) return 'N/A'

  let a = new Date()
  
  if (isString(date)) {
    //OSX 解析
    date = date.replace(/\.\d*/,'').replace(/\+(\d\d)(\d\d)$/,'+$1:$2').replace(/Z$/,'+00:00')
    const objs = date.split(/(?:\=\>|\>\=|\<\=|\=\=|\=|\>|\<|print)/)
    
    for(let i = 0 ; i < objs.length ; i++){
      objs[i] = parseExprDate(objs[i])
    }
    const operator = (date.match(/(\=\>|\>\=|\<\=|\=\=|\=|\>|\<|print)/) || ['','print'])[1]
    if(objs.length == 1) objs[1] = expr
    if(objs.length == 0) objs = [new Date() , expr]
    return execOperate(objs[0] , objs[1] , operator )
  }
  else if(isDate(date)){
    return execOperate(date , expr , 'print' )
  }
  else if( typeof(date) == 'number' ){
    try{
      a = new Date(date)
    }catch(e){}
    return execOperate(a , expr , 'print' )
  }
  else if (!isNaN(date)) {
    let a = new Date()
    try {
      a = parseDate(date);
    } catch (e) {

    }
    return execOperate(a , expr , 'print' )
  }
}

//console.log(moment('d'),moment('w'),moment('M'),moment('-1d'),moment('-1w'),moment('-1M'),moment('$d'),moment('$w'),moment('$M'),moment('-1$d'),moment('-1$w'),moment('-1$M'))
export const now = (expr = 'yyyy-MM-dd hh:mm:ss') => format(new Date(), expr)

export default moment